export default "__VITE_ASSET__4535c734__"